import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import '@/assets/js/index.js'
import '@/assets/scss/index.scss'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_API_BASE
store.dispatch('init')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
